import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import { useFindAllHardwareQuery } from "../../api/api-hooks";
import { Item } from "../../utils/sharedTypes";

interface Props {
  orders: Item[];
}

const HardwareDisplay = ({ orders }: Props) => {
  const { data: allHardware } = useFindAllHardwareQuery({});
  if (allHardware === undefined) return null;
  const orderIds = orders.map((order) => order.id);
  const associatedHardware = allHardware.filter((hardware) => {
    if (hardware.orderId === null) return false;
    else return orderIds.includes(hardware.orderId);
  });
  if (associatedHardware.length === 0)
    return <Typography variant="body2">None</Typography>;
  return (
    <TableContainer>
      <Table size="small" aria-label="hardware table">
        <TableHead>
          <TableRow>
            <TableCell align="right">Serial</TableCell>
            <TableCell align="right">Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {associatedHardware.map((hardware) => (
            <TableRow key={hardware.id}>
              <TableCell align="right">{hardware.serial}</TableCell>
              <TableCell align="right">
                {hardware.hardwareType.typeName}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HardwareDisplay;
